module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('emt-header'), _vm._v(" "), (_vm.login) ? _c('emt-menu-bar') : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1), _vm._v(" "), _c('emt-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31dfd252"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 81
// module chunks = 0